export default {"src":"/_next/static/media/rightLinePromotionCard.48106389.svg","height":30,"width":40,"blurWidth":0,"blurHeight":0};